/** Phase 8 Slice 4.2 — Audit cross-link.
 *
 * Renders a "History" pill that links to the Audit page pre-filtered to the
 * given target. Used in entity detail headers (campaign, autopilot action,
 * approval chain, workflow instance, landing page, CRM connection).
 *
 * Props:
 *   kind: target kind string accepted by /app/audit?target.kind=
 *   id:   target id
 *   label: optional override (defaults to i18n("audit.cross_link"))
 */
import { Link } from "react-router-dom";
import { History } from "lucide-react";
import { useT } from "../../lib/i18n";

export default function AuditHistoryLink({ kind, id, label, testid }) {
  const t = useT();
  if (!kind || !id) return null;
  const href = `/app/audit?target.kind=${encodeURIComponent(kind)}` +
                  `&target.id=${encodeURIComponent(id)}`;
  return (
    <Link to={href}
          data-testid={testid || "audit-history-link"}
          className="inline-flex items-center gap-1 text-xs text-muted-foreground hover:text-foreground transition-colors">
      <History className="h-3.5 w-3.5" />
      {label || t("audit.cross_link")}
    </Link>
  );
}
